import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {getAdminById, openModal} from '../actions';
import {Layout, PageHeader, Spinner} from '../components';
import AdminModal from '../components/Modals/AdminModal';

const AdminDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const {id} = params;
  const {adminById, adminsLoading} = useSelector(s => s.admins);

  const onBack = () => {
    navigate(-1);
  };

  const onDelete = () => {
    dispatch(openModal('DeleteModal', {item: adminById, type: 'admin'}));
  };

  useEffect(() => {
    dispatch(getAdminById(id));
  }, []);

  return (
    <Layout>
      <PageHeader
        onBack={onBack}
        onDelete={onDelete}
        backText="Admins"
        title={`${adminById?.firstName || ''} ${adminById?.lastName || ''}`}
      />
      {!!adminById && <AdminModal adminToEdit={adminById} />}
    </Layout>
  );
};

export default AdminDetails;
